/* ============================================================
   HERZ DER KARTEN – theme.js
   ============================================================ */

// ------------------------------------------------------------
// Drag-to-scroll mit der Maus — EINE Mechanik fuer alle horizontalen/vertikalen
// Streifen (Audit 2026-10-02 CQ-7, M2 Block A). Vorher vier Kopien: Marken-Strip
// und Produkt-Streifen (brand-strip.js), Warenkorbfueller (cart-drawer.js),
// Thumb-Leiste und Trust-Slider der Produktseite (product-page.js) — mit kleinen
// Abweichungen (Trust ohne releasePointerCapture und ohne Klick-Unterdrueckung).
// Regeln (docs/patterns.md «Drag-to-scroll: setPointerCapture erst ab echtem Drag»):
//  - nur pointerType 'mouse'; Touch behaelt natives Scrollen/Snap;
//  - Pointer-Capture erst ab 3px echter Bewegung (Capture beim pointerdown lenkt
//    per Spec auch den click um — Links/Buttons kaemen nie an), beim Loslassen frei;
//  - natives HTML5-Drag (Links/Bilder) per dragstart unterbunden, sonst kapert es
//    den Zug mit pointercancel;
//  - Klick nach echtem Drag in der Capture-Phase unterdrueckt (sonst oeffnet der
//    Link bzw. wechselt das Hauptbild).
// Optionen:
//  achse          'x' (Default) | 'y' | function(el) -> 'x'|'y' (beim pointerdown
//                 gelesen, z.B. Thumb-Leiste: Spalte am Desktop, Reihe mobil)
//  ziel           Selektor: Delegation fuer Streifen, die per Swap ersetzt werden
//                 (Fueller im Drawer-Footer) — die Flaeche wird beim pointerdown
//                 per closest() gesucht, die Listener haengen an `wurzel`
//  nurLinks       nur die linke Maustaste
//  nurBeiUeberlauf Drag nur, wenn die Flaeche in der Achse ueberlaeuft
//  klasseSofort   .is-dragging schon beim pointerdown (Marken-Strip: grabbing-
//                 Cursor beim Druecken), sonst erst ab echtem Drag
// Zuweisung an window statt const: alle Theme-Skripte teilen den globalen Scope.
// ------------------------------------------------------------
window.hdkDragScroll = function (wurzel, opt) {
  if (!wurzel) return;
  const o = opt || {};
  const achseVon = typeof o.achse === 'function' ? o.achse : () => (o.achse || 'x');
  const flaecheVon = (t) => (o.ziel ? (t && t.closest ? t.closest(o.ziel) : null) : wurzel);
  let el = null, vertikal = false, start = 0, startScroll = 0, moved = false;
  wurzel.addEventListener('dragstart', (e) => { if (flaecheVon(e.target)) e.preventDefault(); });
  wurzel.addEventListener('pointerdown', (e) => {
    if (e.pointerType !== 'mouse' || (o.nurLinks && e.button !== 0)) return;
    const f = flaecheVon(e.target);
    if (!f) return;
    const v = achseVon(f) === 'y';
    if (o.nurBeiUeberlauf && (v ? f.scrollHeight <= f.clientHeight : f.scrollWidth <= f.clientWidth)) return;
    el = f;
    vertikal = v;
    moved = false;
    start = v ? e.clientY : e.clientX;
    startScroll = v ? f.scrollTop : f.scrollLeft;
    if (o.klasseSofort) f.classList.add('is-dragging');
  });
  wurzel.addEventListener('pointermove', (e) => {
    if (!el) return;
    const d = (vertikal ? e.clientY : e.clientX) - start;
    if (!moved && Math.abs(d) > 3) {
      moved = true;
      el.classList.add('is-dragging');
      try { el.setPointerCapture(e.pointerId); } catch (err) { /* Capture ist optional */ }
    }
    if (!moved) return;
    if (vertikal) el.scrollTop = startScroll - d;
    else el.scrollLeft = startScroll - d;
  });
  const ende = (e) => {
    if (!el) return;
    el.classList.remove('is-dragging');
    try { el.releasePointerCapture(e.pointerId); } catch (err) { /* nie gecaptured */ }
    el = null;
  };
  wurzel.addEventListener('pointerup', ende);
  wurzel.addEventListener('pointercancel', ende);
  wurzel.addEventListener('click', (e) => {
    if (moved && flaecheVon(e.target)) {
      e.preventDefault();
      e.stopPropagation();
    }
    moved = false;
  }, true);
};

// ------------------------------------------------------------
// Nachgeladene Karten holen (Audit 2026-10-02 CQ-7): Section-Rendering-HTML
// abrufen, parsen, das gesuchte Element waehlen und seine Judge.me-Badges
// lokalisieren, BEVOR es ins DOM geht (localizeReviewBadges unten, erster der
// zwei Aufrufe). Geteilt von «Zuletzt angesehen», «Aehnliche Artikel» und
// «Oft kombiniert mit» (alle drei in product-page.js, seit 2026-10-20);
// Einhaengen, Bewachen ({ watch: true }) und Streifen-Init bleiben beim Aufrufer.
// Liefert das Element oder null (HTTP-Fehler, Netzfehler, Element fehlt).
// ------------------------------------------------------------
window.hdkKartenHolen = function (url, selektor) {
  return fetch(url)
    .then((r) => (r.ok ? r.text() : ''))
    .then((html) => {
      if (!html) return null;
      const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selektor);
      if (el && typeof window.localizeReviewBadges === 'function') window.localizeReviewBadges(el);
      return el;
    })
    .catch(() => null);
};

// ------------------------------------------------------------
// Vertagte Bilder freigeben (img[data-defer-src], Kontrakt unten beim Observer im
// DOMContentLoaded-Block): setzt srcset vor src — der Browser waehlt dann direkt den
// passenden Kandidaten — und entfernt die data-defer-*-Attribute. `wurzel` ist ein
// solches Bild oder ein Container (auch ein geparstes, noch nicht eingehaengtes
// Dokument; darum setAttribute). EINE Regel fuer zwei Aufrufer: den Observer beim
// Seitenaufbau und den Grid-Swap von filter.js (der Section-Swap von cart-page.js rief
// sie vom 20. bis 27.10.2026 fuer das Cross-Selling, das seit dem Audit Warenkorb P-12
// nativ lazy laedt; vorher stand die Funktion in filter.js als Kopie). Nach einem
// Swap gibt es kein LCP-Fenster mehr zu schuetzen; die Swap-Aufrufer geben die
// Quellen darum direkt frei, das loading="lazy" der Karte regelt den Rest
// (Muster «Below-fold-Bilder wirklich vertagen», Sections-API-Falle: der Observer
// kennt nur die Knoten vom Seitenaufbau).
// ------------------------------------------------------------
window.hdkVertagteBilder = function (wurzel) {
  if (!wurzel) return;
  const bilder = wurzel.matches && wurzel.matches('img[data-defer-src]')
    ? [wurzel]
    : (wurzel.querySelectorAll ? wurzel.querySelectorAll('img[data-defer-src]') : []);
  Array.prototype.forEach.call(bilder, (img) => {
    if (img.dataset.deferSrcset) img.setAttribute('srcset', img.dataset.deferSrcset);
    img.setAttribute('src', img.dataset.deferSrc);
    delete img.dataset.deferSrc;
    delete img.dataset.deferSrcset;
  });
};

// ------------------------------------------------------------
// Bild der Produktkarte tauschen (img.product-card__image, snippets/product-card.liquid:
// data-default-src = Ruhebild als Einzel-URL, srcset = responsive Kandidaten). EINE Regel
// fuer alle Tauscher: den 2.-Bild-Hover und den Farbpunkt-Hover der Karte (unten im
// DOMContentLoaded-Block) und die Variantenwahl im Mehr-Dialog von Warenkorbseite und Drawer
// (window.cartMehr in cart-drawer.js, seit 21.10.2026 — dort sonst die vierte Kopie).
//  - zeigen(img, url)  zeigt url voruebergehend: src UND srcset — ein vorhandenes srcset
//    uebersteuert src, ein nacktes img.src bliebe wirkungslos (Lehre «Bildwechsel immer
//    src+srcset»). Das responsive srcset wird beim ersten Tausch gemerkt.
//  - zurueck(img)      zurueck aufs Ruhebild (Ende des Hovers).
//  - ruhebild(img, url) setzt das Ruhebild selbst um (Variantenwahl): der Hover kehrt danach
//    dorthin zurueck statt aufs Hauptbild. Ohne url gilt wieder das Ruhebild aus dem Markup.
// Zuweisung an window statt const: alle Theme-Skripte teilen den globalen Scope.
// ------------------------------------------------------------
window.hdkKartenBild = {
  zeigen(img, url) {
    if (img.srcset && img.dataset.defaultSrcset === undefined) img.dataset.defaultSrcset = img.srcset;
    img.srcset = url;
    img.src = url;
  },
  zurueck(img) {
    if (img.dataset.defaultSrcset !== undefined) img.srcset = img.dataset.defaultSrcset;
    img.src = img.dataset.defaultSrc;
  },
  ruhebild(img, url) {
    if (img.dataset.markupSrc === undefined) {
      img.dataset.markupSrc = img.dataset.defaultSrc || img.src;
      img.dataset.markupSrcset = img.dataset.defaultSrcset !== undefined ? img.dataset.defaultSrcset : img.srcset;
    }
    img.dataset.defaultSrc = url || img.dataset.markupSrc;
    img.dataset.defaultSrcset = url || img.dataset.markupSrcset;
    this.zurueck(img);
  },
};

// ------------------------------------------------------------
// Judge.me-Preview-Badges nachgeladener Karten lokalisieren.
// Single-Source fuer alle drei Flaechen, die Karten per fetch nachladen:
// "Aehnliche Produkte", "Oft kombiniert mit", "Zuletzt angesehen".
//
// Das Metafield {{ product.metafields.judgeme.badge }} liefert den Text
// IMMER englisch ("No reviews"); auf serverseitig ausgelieferten Karten
// uebersetzt Judge.mes eigene Pipeline ihn beim Init. Nachgeladene Karten
// erreicht sie nicht zuverlaessig — sie tragen data-auto-install="false"
// und landen erst nach ihrem Scan im DOM. Ergebnis war ein Mischbild aus
// deutschen und englischen Badges auf derselben Seite (2026-08-06).
// window.JudgeMe.loadBadges() ist KEIN Ersatz: das Objekt existiert nicht
// (der frueher dafuer geladene cdn.judge.me/shopify_v2.js liefert 404,
// verifiziert 2026-08-04) — die Aufrufe waren stille No-Ops.
// Deshalb setzen wir den Text selbst: Anzahl deterministisch aus
// data-number-of-reviews, Wortlaut aus themeStrings (DE/EN).
//
// Seit 2026-10-19 auch auf den serverseitig gerenderten Grids (Kollektion,
// Suche, Startseite, 404; Aufruf im DOMContentLoaded-Block unten, nach dem
// Filter-Swap in filter.js): der Wortlaut ist unserer — seit 19.10. der Zaehler
// in Klammern «(12)» / «(0)» (product.reviews_*; «Keine Bewertungen» wie auch
// «0 Bewertungen» brachen neben den Sternen auf schmalen Karten um, Cyre
// 19.10.) —, nicht Judge.mes Uebersetzung; und das
// Metafeld selbst liefert gemischt («No reviews» 30x, «Keine Bewertungen»
// 8x auf derselben Kollektionsseite, gemessen 19.10.). Damit ist das Theme
// die einzige Quelle des Badge-Texts auf allen Flaechen.
//
// Zwei Aufrufe pro Flaeche, weil der Zeitpunkt des Injects entscheidet:
//   1. auf dem losgeloesten Fragment VOR dem Einhaengen -> kein Aufblitzen;
//   2. auf dem eingehaengten Container MIT { watch: true }.
// Grund fuer (2): Faellt der Inject vor Judge.mes Scan (bei "Oft kombiniert
// mit" lief er bis 2026-10-05 sogar vor DOMContentLoaded), baut dessen Pipeline unsere
// Labels hinterher neu auf — und trifft dabei ihre englischen Defaults,
// solange ihre eigene Uebersetzung noch nicht geladen ist.
//
// Der Watcher laeuft BEWUSST ohne Abschalt-Bedingung. Zwei Enden wurden
// gebaut und empirisch verworfen (2026-08-06, je 5 Laeufe kalt/warm):
//   - festes 15s-Fenster -> bei kaltem Cache schrieb die Pipeline spaeter,
//     "Oft kombiniert mit" blieb englisch;
//   - Judge.mes eigene Fertig-Markierung 'jdgm--done-setup'
//     (window.jdgm.DONE_SETUP_CLASS) -> die Klasse sitzt schon VOR dem
//     letzten Schreibvorgang, danach kippte "Aehnliche Produkte".
// Kosten sind vernachlaessigbar: beobachtet werden nur die beiden kleinen
// Karten-Container, und apply() schreibt nur bei echter Abweichung — die
// eigene Aenderung loest also keine weitere Runde aus, und Judge.me reagiert
// seinerseits nicht auf Textaenderungen (kein Ping-Pong, verifiziert).
// Wird der Container spaeter ersetzt, verfaellt der Observer mit ihm.
// ------------------------------------------------------------
/* VENDOR:jdgm-badge-i18n */
window.localizeReviewBadges = function (root, options) {
  const strings = window.themeStrings;
  if (!root || !root.querySelectorAll || !strings || !strings.reviewsNone) return;

  function apply() {
    root.querySelectorAll('.jdgm-prev-badge').forEach(badge => {
      const label = badge.querySelector('.jdgm-prev-badge__text');
      if (!label) return;
      const n = parseInt(badge.getAttribute('data-number-of-reviews'), 10) || 0;
      const wanted = n === 0 ? strings.reviewsNone
        : n === 1 ? strings.reviewsOne
        : strings.reviewsMany.replace('__N__', n);
      if (label.textContent.trim() !== wanted) label.textContent = wanted;
    });
  }

  apply();
  if (!options || !options.watch || typeof MutationObserver !== 'function') return;
  new MutationObserver(apply).observe(root, { subtree: true, childList: true, characterData: true });
};

// ------------------------------------------------------------
// Fokus-Management fuer modale Panels (Cart-Drawer, Filter-Drawer
// mobil, Produkt-Lightbox, seit 21.10.2026 der Mehr-Dialog — ein natives <dialog>, dem nur
// das zyklische Tab fehlt, window.cartMehr in cart-drawer.js; seit 26.10.2026 auch ueber dem
// offenen Drawer, darum activate(panel, { ueber: true }))
// — Single-Source, da das Muster identisch gebraucht wird. activate(): Ausloeser merken, ins Panel
// fokussieren, Tab/Shift+Tab zyklisch im Panel halten (Fokus-Falle).
// deactivate(): Falle loesen, Fokus auf den Ausloeser zurueck (bzw. mit { ueber }: die Falle
// des darunterliegenden Panels wieder einsetzen).
// ------------------------------------------------------------
window.modalFocus = (function () {
  // iframe gehoert dazu (A11Y-5, 2026-08-29): der Lightbox-Slide eines Fremdvideos
  // ist ein iframe, und der ist von Haus aus fokussierbar. Fehlte er in der Liste,
  // sprang Tab aus der Falle heraus und Escape/Pfeile waren tot, sobald der Fokus im
  // Player lag. Der Fokus wird bewusst NICHT automatisch in den iframe gelegt —
  // dort greift unsere Tastensteuerung nicht, das ist Sache des Nutzers.
  // summary gehoert dazu (Audit 2026-10-02, A11Y-3): die Filter-Sektionen sind
  // <details>; fehlte <summary>, kannte die Falle im Filter-Drawer nur «Schliessen»
  // und «Verfuegbarkeit» — Tab sprang zwischen beiden, die uebrigen Sektionen,
  // «Zuruecksetzen» und «Anzeigen» waren per Tastatur unerreichbar.
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, iframe, [tabindex]:not([tabindex="-1"])';
  let trapHandler = null, restoreTo = null, activePanel = null;
  // Ein Panel, ueber dem das aktive liegt (seit 26.10.2026: der Mehr-Dialog ueber dem offenen
  // Cart-Drawer, cart-drawer.js window.cartMehr). activate(panel, { ueber: true }) merkt sich
  // Panel und Ausloeser des darunterliegenden; deactivate() setzt dessen Falle wieder ein,
  // ohne den Fokus zu bewegen (das tut der Aufrufer), und dessen Ausloeser bleibt das Ziel
  // seines eigenen deactivate(). Ohne { ueber } loest activate wie bisher jedes aktive Panel ab.
  let darunter = null;

  function focusables(panel) {
    // offsetParent-Filter: display:none-Teile (z.B. Drawer-Header in der
    // Desktop-Sidebar) sind nicht fokussierbar und duerfen die Falle nicht verwirren
    return Array.prototype.filter.call(
      panel.querySelectorAll(FOCUSABLE),
      (el) => el.offsetParent !== null
    );
  }

  function loesen() {
    if (trapHandler) document.removeEventListener('keydown', trapHandler);
    trapHandler = null;
    activePanel = null;
  }

  function setzen(panel) {
    activePanel = panel;
    trapHandler = (e) => {
      if (e.key !== 'Tab') return;
      const list = focusables(panel);
      if (!list.length) return;
      const first = list[0], last = list[list.length - 1];
      const active = document.activeElement;
      // Fokus ausserhalb der Liste (Panel-Container selbst, oder nach einem
      // AJAX-Inhaltstausch auf <body> gefallen) -> zurueck in die Falle lenken
      if (list.indexOf(active) === -1) {
        e.preventDefault();
        (e.shiftKey ? last : first).focus();
        return;
      }
      if (e.shiftKey && active === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', trapHandler);
  }

  return {
    activate(panel, opts) {
      if (!panel || activePanel === panel) return;
      darunter = (opts && opts.ueber && activePanel) ? { panel: activePanel, restoreTo } : null;
      loesen();
      restoreTo = document.activeElement;
      // Container statt erstem Button fokussieren: kein sichtbarer Fokus-Ring nach
      // Maus-/Touch-Oeffnen (auf Mobile erschien der UA-Ring in Blau auf dem X),
      // und Screenreader sagen das aria-label des Dialogs an. Erster Tab landet
      // natuerlich auf dem ersten fokussierbaren Element im Panel.
      if (!panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '-1');
      panel.focus({ preventScroll: true });
      setzen(panel);
    },
    deactivate(opts) {
      loesen();
      const doRestore = !opts || opts.restore !== false;
      if (doRestore && restoreTo && document.contains(restoreTo)) {
        try { restoreTo.focus(); } catch (e) { /* Element evtl. nicht mehr fokussierbar */ }
      }
      restoreTo = null;
      // Lag das Panel ueber einem anderen (activate mit { ueber: true }), gilt wieder dessen
      // Falle mit dessen Ausloeser.
      if (darunter) {
        const d = darunter;
        darunter = null;
        if (document.contains(d.panel)) {
          restoreTo = d.restoreTo;
          setzen(d.panel);
        }
      }
    }
  };
})();

document.addEventListener('DOMContentLoaded', () => {

  // ----------------------------------------------------------
  // Judge.me-Badges der serverseitigen Grids: Wortlaut aus unseren Locales,
  // bewacht, weil Judge.mes Init den Text danach (neu) schreibt (Hintergrund
  // bei window.localizeReviewBadges oben). Streifen rufen es selbst nach dem
  // Nachladen; der Kollektions-Filter nach seinem Grid-Swap (filter.js).
  // ----------------------------------------------------------
  document.querySelectorAll('.product-grid').forEach((grid) => {
    if (typeof window.localizeReviewBadges === 'function') window.localizeReviewBadges(grid, { watch: true });
  });

  // ----------------------------------------------------------
  // Vertagte Bilder (Performance-Audit 2026-09-03, H2): <img data-defer-src
  // [data-defer-srcset]> bekommt src/srcset erst 600 px vor dem Viewport.
  // Warum nicht loading="lazy": Chrome laedt "lazy" auf langsamen Netzen
  // 1'250–4'000 px voraus — die Fallback-Karten «Aehnliche Artikel», das
  // About-Foto und die Zahlungslogos (zusammen ~136 KB) liefen so ab ~1.1 s
  // im Ladefenster bis DOMContentLoaded mit. Kontrakt der Attributnamen:
  // snippets/product-card.liquid (defer), sections/about-mini.liquid,
  // snippets/payment-icons.liquid (defer), sections/footer.liquid (toppreise-
  // Badge), sections/gradedguard-landing.liquid. Bewusst NICHT data-src: das
  // tragen die Hero-Slides 2+ (hero.js hydriert die nach eigener Regel).
  // Das Cross-Selling der Warenkorbseite trug defer vom 20. bis 27.10.2026; seither
  // nativ lazy (Audit Warenkorb P-12: seine erste Karte ist bei kurzem Warenkorb das
  // Desktop-LCP). Freigabe selbst: window.hdkVertagteBilder
  // oben. Ohne IntersectionObserver: sofort hydrieren.
  // ----------------------------------------------------------
  const deferredImgs = Array.from(document.querySelectorAll('img[data-defer-src]'));
  if (deferredImgs.length) {
    if ('IntersectionObserver' in window) {
      const deferIo = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          window.hdkVertagteBilder(entry.target);
          deferIo.unobserve(entry.target);
        });
      }, { rootMargin: '600px 0px' });
      deferredImgs.forEach((img) => deferIo.observe(img));
    } else {
      window.hdkVertagteBilder(document);
    }
  }

  // ----------------------------------------------------------
  // Announcement Bar – Marquee-Tempo (Animation laeuft nur Mobile <600px, s. CSS)
  // Konstante Laufgeschwindigkeit statt fixer Dauer: die Animationsdauer wird aus
  // der gemessenen Trackbreite abgeleitet (Texte/Schriftmetrik variieren). Track =
  // Inhalt doppelt, Loop bei -50% -> massgeblich ist die halbe scrollWidth.
  // ----------------------------------------------------------
  const annTrack = document.querySelector('.announcement-bar__track--marquee');
  if (annTrack) {
    const MARQUEE_SPEED = 40; // px/s
    const syncMarqueeSpeed = () => {
      const halfWidth = annTrack.scrollWidth / 2;
      if (halfWidth > 0) {
        annTrack.style.setProperty('--ann-marquee-dur', (halfWidth / MARQUEE_SPEED).toFixed(2) + 's');
      }
    };
    syncMarqueeSpeed();
    window.addEventListener('resize', syncMarqueeSpeed);
    // Webfont laedt nach DOMContentLoaded -> Breite aendert sich, Tempo nachziehen
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncMarqueeSpeed);
  }

  // ----------------------------------------------------------
  // Menü (#mobile-menu): Mobile-Burger UND Desktop-Sticky-Burger
  // oeffnen dasselbe Panel — alle [data-action="open-menu"] binden
  // ----------------------------------------------------------
  const burgerBtns = Array.from(document.querySelectorAll('[data-action="open-menu"]'));
  const mobileMenu = document.getElementById('mobile-menu');

  if (burgerBtns.length && mobileMenu) {
    // Menue scrollt intern: max-height = Restviewport ab Menue-Oberkante, GEMESSEN
    // (Announcement-Bar/Stuck-Zustand verschieben die Oberkante — Fixwerte stimmen nie;
    // gleiches Prinzip wie --sticky-atc-h). Erst nach dem Einblenden messbar.
    const syncMenuMaxHeight = () => {
      if (!mobileMenu.classList.contains('is-open')) return;
      const top = mobileMenu.getBoundingClientRect().top;
      mobileMenu.style.maxHeight = Math.max(200, window.innerHeight - top) + 'px';
    };

    const setMenuOpen = (isOpen) => {
      mobileMenu.classList.toggle('is-open', isOpen);
      mobileMenu.setAttribute('aria-hidden', !isOpen);
      burgerBtns.forEach((b) => b.setAttribute('aria-expanded', isOpen));
      // Hintergrund sperren wie Cart-/Filter-Drawer (body.<x>-active { overflow:hidden }):
      // ohne Lock scrollte die Seite HINTER dem Menue — und wurde der Header dabei sticky,
      // mass setStuck die Fluss-Hoehe inkl. offenem Menue -> Spacer-Luecke ueber dem Hero.
      document.body.classList.toggle('mobile-menu-active', isOpen);
      if (isOpen) {
        syncMenuMaxHeight();
      } else {
        mobileMenu.style.maxHeight = '';
      }
    };

    window.addEventListener('resize', syncMenuMaxHeight);

    burgerBtns.forEach((btn) => {
      btn.addEventListener('click', () => setMenuOpen(!mobileMenu.classList.contains('is-open')));
    });

    // Menü schließen wenn außerhalb geklickt wird
    document.addEventListener('click', (e) => {
      if (!mobileMenu.contains(e.target) && !burgerBtns.some((b) => b.contains(e.target))) {
        setMenuOpen(false);
      }
    });

    // Escape schliesst das Menue (A11Y-9, 2026-08-29) — es war das einzige Overlay
    // ohne Escape-Ausstieg (Cart-Drawer, Filter-Drawer und Lightbox koennen es laengst).
    // Fokus zurueck auf den ausloesenden Burger: sonst faellt er beim Schliessen ans
    // <body> und die Tastatur-Navigation beginnt wieder ganz oben. Welcher Burger
    // sichtbar ist, haengt am Breakpoint/Stuck-Zustand -> offsetParent entscheidet.
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' || !mobileMenu.classList.contains('is-open')) return;
      setMenuOpen(false);
      const sichtbarerBurger = burgerBtns.find((b) => b.offsetParent !== null);
      if (sichtbarerBurger) sichtbarerBurger.focus();
    });

    // Aufklappbare Kategorie-Gruppen im Mobile-Menü
    mobileMenu.querySelectorAll('[data-action="toggle-submenu"]').forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const submenu = toggle.nextElementSibling;
        if (!submenu) return;
        const isOpen = submenu.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen);
        submenu.setAttribute('aria-hidden', !isOpen);
      });
    });
  }

  // ----------------------------------------------------------
  // Sticky-Header: Stuck-Zustand via 1px-Sentinel vor dem Header.
  // Stuck = position:fixed (sticky scheitert am Shopify-Section-
  // Wrapper, s. theme.css) + Spacer in Header-Hoehe gegen den
  // Layout-Sprung. Desktop blendet gescrollt die Kategorien-Zeile
  // aus; der Sticky-Burger klappt sie bei Bedarf wieder auf.
  // ----------------------------------------------------------
  const siteHeader = document.querySelector('.site-header');
  const headerSentinel = document.querySelector('.header-sentinel');
  const headerSpacer = document.querySelector('.header-spacer');
  const catnavBtn = document.querySelector('[data-action="toggle-catnav"]');

  if (siteHeader && headerSentinel && 'IntersectionObserver' in window) {
    let stuck = false;
    let flowHeight = 0; // Header-Hoehe im Fluss (inkl. Kategorien-Zeile)

    const setCatnavOpen = (open) => {
      siteHeader.classList.toggle('show-catnav', open);
      if (catnavBtn) catnavBtn.setAttribute('aria-expanded', open);
    };

    const syncSpacer = () => {
      if (headerSpacer) headerSpacer.style.height = stuck ? flowHeight + 'px' : '0px';
    };

    // Hoehe des fixierten Headers als --header-h am <html> (0 px, solange er im Fluss steht
    // und nichts ueberdeckt). theme.css haelt damit bei Tastatur-Navigation den Fokus unter
    // dem Header frei (scroll-padding-top, WCAG 2.4.11; Audit Warenkorb 26.10.2026 A-2 —
    // Shift+Tab landete auf Elementen unter dem Header). Gemessen statt angenommen: im
    // Stuck-Zustand klappen Kategorien-Zeile und Suche auf, der ResizeObserver zieht nach.
    const syncHeaderH = () => {
      document.documentElement.style.setProperty('--header-h', stuck ? siteHeader.offsetHeight + 'px' : '0px');
    };
    if ('ResizeObserver' in window) new ResizeObserver(() => { if (stuck) syncHeaderH(); }).observe(siteHeader);

    const setStuck = (on) => {
      if (on === stuck) return;
      // VOR dem Klassenwechsel messen: der Spacer muss exakt die Hoehe ersetzen, die der
      // Header im Fluss belegt hat (inkl. Kategorien-Zeile). Mit der Stuck-Hoehe (ohne
      // Zeile) spraenge der Content beim Andocken um die Zeilenhoehe nach oben und der
      // Rueckweg wuerde asymmetrisch (1 Tick runter, 2 Ticks hoch).
      if (on) flowHeight = siteHeader.offsetHeight;
      stuck = on;
      siteHeader.classList.toggle('is-stuck', on);
      if (!on) {
        setCatnavOpen(false); // oben angekommen: Zeile ist regulaer sichtbar
        // Aufgeklappte Sticky-Suche zuruecksetzen — sonst stuende die Zeile beim
        // naechsten Andocken sofort offen (Funktion ist unten definiert; setStuck
        // laeuft erst nach der Initialisierung, Hoisting-Reihenfolge unkritisch)
        setMobileSearchOpen(false);
      }
      syncSpacer();
      syncHeaderH();
    };

    new IntersectionObserver((entries) => {
      setStuck(!entries[0].isIntersecting);
    }).observe(headerSentinel);

    window.addEventListener('resize', syncSpacer);

    if (catnavBtn) {
      catnavBtn.addEventListener('click', () => {
        setCatnavOpen(!siteHeader.classList.contains('show-catnav'));
      });
      // Klick ausserhalb des Headers klappt die Zeile wieder ein
      document.addEventListener('click', (e) => {
        if (siteHeader.classList.contains('show-catnav') && !siteHeader.contains(e.target)) {
          setCatnavOpen(false);
        }
      });
    }

    // Sticky-Suche Mobile (Cyre 2026-08-09): gescrollt ist die Suchzeile zu — die
    // Lupe in Zeile 1 klappt sie auf/zu (.show-mobile-search wirkt nur zusammen
    // mit .is-stuck, s. theme.css) und fokussiert beim Oeffnen das Feld.
    const stickySearchBtn = document.querySelector('[data-action="toggle-mobile-search"]');
    const setMobileSearchOpen = (open) => {
      siteHeader.classList.toggle('show-mobile-search', open);
      if (stickySearchBtn) stickySearchBtn.setAttribute('aria-expanded', open);
      // preventScroll: focus() scrollt sonst die Seite (das Feld liegt im fixed
      // Header, der Browser will es trotzdem "in den Viewport" holen)
      if (open) document.getElementById('mobile-search-input')?.focus({ preventScroll: true });
    };
    if (stickySearchBtn) {
      stickySearchBtn.addEventListener('click', () => {
        setMobileSearchOpen(!siteHeader.classList.contains('show-mobile-search'));
      });
    }
  }

  // ----------------------------------------------------------
  // Produktkarte — Hover-Bildwechsel (2. Bild). NUR Hover-Geraete (Desktop) — auf
  // Mobile/Touch uebernimmt das CSS (.product-card__hover-img, @media hover:none),
  // damit der Wechsel am selben :hover-Trigger wie Goldrand/Zoom haengt.
  // ----------------------------------------------------------
  if (window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', e => {
      // Swatch-Zone ausgenommen: dort steuern die Farbpunkte das Bild (Handler unten) —
      // seit data-hover-src auch auf Varianten-Karten liegt (2026-07-29), wuerde der
      // generische Hover sonst zwischen den Punkten aufs 2. Bild zurueckflackern
      if (e.target.closest('.product-card__variants')) return;
      const img = e.target.closest('.product-card__image-wrap')?.querySelector('img[data-hover-src]');
      // srcset uebersteuert src: Tausch ueber window.hdkKartenBild (oben), src + srcset
      if (img) window.hdkKartenBild.zeigen(img, img.dataset.hoverSrc);
    });
    document.addEventListener('mouseout', e => {
      if (e.target.closest('.product-card__variants')) return; // Reset macht der Swatch-Handler
      const img = e.target.closest('.product-card__image-wrap')?.querySelector('img[data-hover-src]');
      if (img) window.hdkKartenBild.zurueck(img);
    });

    // Verfuegbarkeits-Blase der Produktkarte (snippets/product-card.liquid, CSS
    // theme.css «Verfuegbarkeits-Blase»): ein Popover im Top-Layer, weil die Karte
    // mit overflow: hidden clippt und die Sprechblase neben dem Punkt ueber die
    // Nachbarkarte ragt. Hier: oeffnen beim Hover ueber den Punkt, Lage messen
    // (links vom Punkt, Oberkante knapp ueber der Punktmitte; fehlt links der
    // Platz, rechts davon mit gespiegeltem Pfeil; unten am Viewport geklemmt, der
    // Pfeil folgt der Punktmitte), schliessen beim Verlassen von Punkt+Blase, beim
    // Scroll nachfuehren (fixed-Lage, s. unten). Delegiert, weil Karten per
    // Sections-API nachgeladen werden (Filter, Streifen). Die Lieferzeile («Morgen
    // geliefert» …) ist zeitabhaengig und wird nie in Liquid gerendert (CDN-Cache,
    // docs/patterns.md «Zeitabhaengige Anzeige»): bei jedem Oeffnen neu aus
    // hdk.lieferAussage — dieselbe Regel und dieselben Locale-Strings wie die
    // Lieferzeile der Produktseite; sie existiert nur bei kaufbarer Lagerware.
    // Ohne Popover-API (showPopover) bleibt die Blase aus — wie frueher ohne title.
    if ('showPopover' in HTMLElement.prototype) {
      const TIP_ABSTAND = 8;   // Luecke Punkt -> Blase = Pfeillaenge (CSS border 8px)
      const TIP_PFEIL_Y = 20;  // Pfeil-/Punktmitte ab Blasen-Oberkante im Normalfall
      const TIP_RAND = 8;      // Mindestabstand zum Viewport-Rand
      const tipSchliessen = (tip) => { if (tip.matches(':popover-open')) tip.hidePopover(); };
      const tipAlleSchliessen = () => {
        document.querySelectorAll('.product-card__tip:popover-open').forEach(tipSchliessen);
      };
      const tipOeffnen = (stock) => {
        const tip = stock.querySelector('.product-card__tip');
        const dot = stock.querySelector(':scope > .stock-dot');
        if (!tip || !dot) return;
        const zeile = tip.querySelector('[data-card-lieferung]');
        if (zeile && window.hdk && window.themeStrings) {
          const lang = document.documentElement.lang || 'de';
          const text = window.hdk.lieferAussage(new Date(), lang, window.themeStrings).text;
          const ziel = zeile.lastElementChild;
          // innerHTML-Quelle ist eigenes Markup (_html-Locale-String mit .delivery-when)
          if (ziel.innerHTML !== text) ziel.innerHTML = text;
          zeile.hidden = false;
        }
        const d = dot.getBoundingClientRect();
        // Punkt aus dem Viewport gescrollt -> Blase zu (sonst klebte sie am Rand)
        if (d.bottom < 0 || d.top > window.innerHeight) { tipSchliessen(tip); return; }
        if (!tip.matches(':popover-open')) { tipAlleSchliessen(); tip.showPopover(); }
        // Messen geht erst offen (display: none davor)
        const b = tip.getBoundingClientRect();
        const mitte = d.top + d.height / 2;
        // Default LINKS vom Punkt (seit 20.10.2026, Cyre: der Punkt steht jetzt am linken
        // Kartenrand in der Lagerzeile — rechts aufgehend deckte die Blase die eigene
        // Karte; links liegt sie ueber der Nachbarkarte bzw. dem Rand). Fehlt links der
        // Platz bis zum Viewport-Rand, rechts vom Punkt mit gespiegeltem Pfeil.
        let x = d.left - TIP_ABSTAND - b.width;
        const links = x >= TIP_RAND;
        if (!links) x = Math.min(d.right + TIP_ABSTAND, window.innerWidth - TIP_RAND - b.width);
        let y = mitte - TIP_PFEIL_Y;
        y = Math.min(y, window.innerHeight - TIP_RAND - b.height);
        y = Math.max(TIP_RAND, y);
        tip.classList.toggle('product-card__tip--links', links);
        tip.style.setProperty('--tip-x', x + 'px');
        tip.style.setProperty('--tip-y', y + 'px');
        tip.style.setProperty('--tip-pfeil-y', Math.min(Math.max(mitte - y, 14), b.height - 14) + 'px');
      };
      document.addEventListener('mouseover', e => {
        const stock = e.target.closest('.product-card__stock');
        if (stock) tipOeffnen(stock);
      });
      document.addEventListener('mouseout', e => {
        const stock = e.target.closest('.product-card__stock');
        if (!stock) return;
        // relatedTarget innerhalb von Punkt + Blase (die Blase ist DOM-Kind des Punkts,
        // auch im Top-Layer) -> nur ein Wechsel innerhalb, nichts schliessen
        if (e.relatedTarget && stock.contains(e.relatedTarget)) return;
        const tip = stock.querySelector('.product-card__tip');
        if (tip) tipSchliessen(tip);
      });
      // Scroll (Capture: auch Scroll-Container): offene Blase der Punktlage nachfuehren,
      // statt sie zu schliessen — wer auf dem Punkt ruht und scrollt, verliert sie sonst
      // ohne Weg zurueck (ein neues mouseover kommt erst beim Verlassen und Wiederkehren).
      document.addEventListener('scroll', () => {
        document.querySelectorAll('.product-card__tip:popover-open').forEach(t => {
          const stock = t.closest('.product-card__stock');
          if (stock) tipOeffnen(stock);
        });
      }, true);
    }
  }

  // ----------------------------------------------------------
  // Produktkarte — Farbpunkt-Hover: Hauptbild auf die jeweilige Variante (erstes Bild).
  // Farb-Produkte tragen kein data-hover-src (s. product-card.liquid) -> der generische
  // 2.-Bild-Hover oben greift dort nicht; die Punkte steuern das Bild.
  // ----------------------------------------------------------
  document.addEventListener('mouseover', e => {
    const sw = e.target.closest('.product-card__swatch');
    if (!sw || !sw.dataset.variantImage) return;
    const img = sw.closest('.product-card__image-wrap')?.querySelector('.product-card__image');
    if (!img) return;
    window.hdkKartenBild.zeigen(img, sw.dataset.variantImage);
    // Preis dieser Variante in die Karten-Preisanzeige (Default-Preis "ab CHF X" einmal merken)
    const priceEl = sw.closest('.product-card')?.querySelector('.product-card__price');
    if (priceEl && sw.dataset.variantPrice) {
      if (priceEl.dataset.defaultPrice === undefined) priceEl.dataset.defaultPrice = priceEl.textContent;
      priceEl.textContent = sw.dataset.variantPrice;
    }
  });
  document.addEventListener('mouseout', e => {
    const sw = e.target.closest('.product-card__swatch');
    if (!sw) return;
    // Wechsel direkt zu einem anderen Punkt -> nicht zwischendurch aufs Default zuruecksetzen (kein Flackern)
    if (e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('.product-card__swatch')) return;
    const img = sw.closest('.product-card__image-wrap')?.querySelector('.product-card__image');
    if (!img) return;
    window.hdkKartenBild.zurueck(img);
    // Preis zuruecksetzen (Verlassen aller Punkte)
    const priceEl = sw.closest('.product-card')?.querySelector('.product-card__price');
    if (priceEl && priceEl.dataset.defaultPrice !== undefined) priceEl.textContent = priceEl.dataset.defaultPrice;
  });

  // ----------------------------------------------------------
  // Produktkarte — Variantenbilder beim Karten-Hover vorwaermen (Cache), damit der
  // Punkt-Hover beim ersten Mal snappy ist. Nur Hover-Geraete (Desktop); Mobile zeigt
  // keine Punkte -> kein Prefetch (Seitenladezeit/Daten schonen). Einmal pro Karte.
  // ----------------------------------------------------------
  if (window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', e => {
      const card = e.target.closest('.product-card');
      if (!card || card.dataset.swatchesPrefetched) return;
      const swatches = card.querySelectorAll('.product-card__swatch[data-variant-image]');
      if (!swatches.length) return;
      card.dataset.swatchesPrefetched = '1';
      swatches.forEach(sw => { const im = new Image(); im.src = sw.dataset.variantImage; });
    });
  }

  // ----------------------------------------------------------
  // Footer-Link «Cookie-Einstellungen» (href="#reopenBanner") oeffnet den
  // Pandectes-Banner erneut — ueber das Einwilligungs-Widget als Motor.
  //
  // WARUM SO (2026-09-02, docs/vendor-kopplungen.md «Pandectes»): Pandectes
  // verdrahtet #reopenBanner-Links nur im Premium-Plan (customTrigger), und
  // die JavaScript-API window.Pandectes wird nur im Enterprise-Plan
  // installiert (Core-Script: `da(plan) && Ui()`). Im Plan «plus» oeffnet
  // allein das Einwilligungs-Widget den Banner wieder. Das Widget lebt im
  // OFFENEN Shadow-Root von <pandectes-cmp> als Element `.widget`, dessen
  // Klick-Handler intern dieselbe Funktion ruft wie der Premium-Link. Es ist
  // per Custom-CSS in der Pandectes-App versteckt (`.widget { display: none }`)
  // — ein programmatischer click() feuert trotzdem.
  //
  // Fallback statt stillem Nichts: Fehlt das Widget (Pandectes-Update hat die
  // Klasse umbenannt, Shadow-Root geschlossen, oder der Banner steht ohnehin
  // offen und das Widget ist noch nicht gerendert), fuehrt der Link auf die
  // Datenschutzseite (data-fallback, locale-bewusst aus Liquid). Headless-
  // Browser sehen das Widget nie (Pandectes rendert Bots nichts), darum kann
  // vendor-smoke diese Kopplung nicht pruefen — Bruch faellt am Fallback auf.
  // ----------------------------------------------------------
  document.addEventListener('click', e => {
    /* VENDOR:pandectes-reopen */
    const link = e.target.closest('a[href="#reopenBanner"]');
    if (!link) return;
    e.preventDefault();
    const host = document.querySelector('pandectes-cmp');
    const widget = host && host.shadowRoot && host.shadowRoot.querySelector('.widget');
    if (widget) { widget.click(); return; }
    if (link.dataset.fallback) window.location.href = link.dataset.fallback;
  });

  // ----------------------------------------------------------
  // Versand-Info-Blase (snippets/cart-shipping-info.liquid) — Tap/Klick-Toggle
  // fuer alle Geraete, Hover kommt per CSS nur auf Zeigergeraeten dazu.
  // Delegiert auf document: der Drawer-Inhalt wird per Sections-API ersetzt,
  // direkt gebundene Listener waeren nach jeder Mengenaenderung weg.
  // ----------------------------------------------------------
  const shippingInfoSetzen = (wrap, offen) => {
    wrap.classList.toggle('is-open', offen);
    const btn = wrap.querySelector('[data-shipping-info-toggle]');
    if (btn) btn.setAttribute('aria-expanded', offen ? 'true' : 'false');
  };
  const shippingInfoAlleSchliessen = (ausser) => {
    document.querySelectorAll('.cart-shipping-info.is-open').forEach(w => {
      if (w !== ausser) shippingInfoSetzen(w, false);
    });
  };
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-shipping-info-toggle]');
    if (btn) {
      const wrap = btn.closest('.cart-shipping-info');
      shippingInfoAlleSchliessen(wrap);
      shippingInfoSetzen(wrap, !wrap.classList.contains('is-open'));
      return;
    }
    if (e.target.closest('.cart-shipping-info__bubble')) return;
    shippingInfoAlleSchliessen();
  });
  // Capture-Phase: laeuft VOR dem Escape-Handler des Cart-Drawers (Bubble-
  // Phase auf document). Ist eine Blase offen — per Klick/Enter (is-open) oder per Hover —,
  // schliesst Escape nur sie; der Drawer bleibt auf, das naechste Escape trifft dann ihn
  // (Audit Warenkorb A-5, WCAG 1.4.13: Zusatzinhalt muss ohne Zeigerbewegung schliessbar sein).
  // Die Hover-Blase bleibt danach zu, bis der Zeiger die Zeile verlaesst (is-unterdrueckt).
  // Tastaturfokus allein oeffnet seit Block 1 nichts mehr (cart-drawer.css).
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    const offen = document.querySelector('.cart-shipping-info.is-open');
    const hover = Array.prototype.find.call(document.querySelectorAll('.cart-shipping-info'), w => w.matches(':hover') && !w.classList.contains('is-unterdrueckt'));
    if (!offen && !(hover && window.matchMedia('(hover: hover)').matches)) return;
    shippingInfoAlleSchliessen();
    if (hover) {
      hover.classList.add('is-unterdrueckt');
      hover.addEventListener('mouseleave', () => hover.classList.remove('is-unterdrueckt'), { once: true });
    }
    e.stopPropagation();
  }, true);

  // ----------------------------------------------------------
  // Footer-Klappen (docs/decisions.md 2026-10-25 (4)). Unter 900 sind
  // «Service», «Herz der Karten» und «Social Media» native <details>, ab 900
  // die Spalten wie bisher. Das Markup kommt offen (No-JS: alles sichtbar, Desktop haengt an
  // keinem Skript); den Anfangszustand «zu» unter 900 setzt das Inline-Skript
  // in sections/footer.liquid vor dem ersten Paint. Hier nur, was danach
  // kommt: Breitenwechsel (Drehen, Fenster ziehen) setzen den Zustand des
  // neuen Bands, und ab 900 ist die Kopfzeile eine Ueberschrift — ihr Klick
  // klappt nichts zu, und sie steht nicht im Tab-Fluss. Der Anfangszustand
  // wird hier bewusst NICHT nochmals gesetzt: wer vor diesem (deferred)
  // Skript schon eine Klappe geoeffnet hat, behaelt sie offen.
  // ----------------------------------------------------------
  const footerDesktop = window.matchMedia('(min-width: 900px)');
  const footerKopfzeilenSetzen = () => {
    document.querySelectorAll('.footer__fold-summary').forEach(s => {
      if (footerDesktop.matches) s.setAttribute('tabindex', '-1');
      else s.removeAttribute('tabindex');
    });
  };
  footerKopfzeilenSetzen();
  footerDesktop.addEventListener('change', () => {
    document.querySelectorAll('.footer__fold').forEach(d => { d.open = footerDesktop.matches; });
    footerKopfzeilenSetzen();
  });
  document.addEventListener('click', e => {
    if (footerDesktop.matches && e.target.closest('.footer__fold-summary')) e.preventDefault();
  });

  // ----------------------------------------------------------
  // Newsletter-Anmeldung im Footer ohne Seitenwechsel (2026-09-15).
  // {% form 'customer' %} postet nativ auf /contact#newsletter-form; Shopify
  // antwortet mit einem Redirect auf die Ausgangsseite, der Browser laedt sie
  // neu (oben) und springt dann per Anker zum Formular — der sichtbare
  // Hoch-Runter-Scroll. Hier laeuft derselbe POST per fetch, die Antwort
  // landet im Status-Slot, die Seite bleibt exakt stehen.
  //
  // Shopifys Spam-Schutz (hCaptcha, Bootstrap in content_for_header) haengt
  // sich an genau dieses Formular: sein Submit-Listener unterbindet den
  // nativen Submit, holt ein Token, haengt es als <input name=
  // "h-captcha-response"> an und ruft dann die submit()-Funktion des
  // Formulars auf — und zwar DIE, die er beim Binden (erster focusin/change
  // im Formular) vorgefunden hat («function» == typeof form.submit ?
  // form.submit : Prototyp). Darum wird form.submit HIER, vor jeder
  // Nutzer-Interaktion, durch die fetch-Variante ersetzt: der Vendor ruft sie
  // nach dem Token-Holen mit vollstaendigem Formular auf. Ohne Token lehnt
  // /contact mit 400 «Missing CAPTCHA token» ab (curl-Beleg 15.09.2026) —
  // ein eigener Submit-Listener kaeme VOR dem Token und ginge leer aus.
  // Ist die Antwort weder Erfolg noch ein gerenderter Formularfehler, gibt
  // es zwei Ausweichwege: ein Redirect (sichtbares Captcha auf /challenge)
  // wird als Navigation nachvollzogen; alles andere (Shopifys Bot-
  // Zwischenseite «Verifying your connection» mit 403 — ueber den Dev-
  // Server-Proxy reproduzierbar, 15.09.2026) geht als nativer Submit raus,
  // Shopify fuehrt die Zwischenseite dann selbst zu Ende. Nur der
  // Netzwerkfehler (fetch wirft) endet im Fehlertext.
  // ----------------------------------------------------------
  const newsletterForm = document.getElementById('newsletter-form');
  if (newsletterForm) {
    /* VENDOR:captcha-form-submit */
    const nativeSubmit = HTMLFormElement.prototype.submit.bind(newsletterForm);
    const statusSlot = newsletterForm.querySelector('[data-newsletter-status]');
    const submitBtn = newsletterForm.querySelector('button[type="submit"]');
    const zeigeStatus = (klasse, text) => {
      const p = document.createElement('p');
      p.className = klasse;
      p.textContent = text;
      statusSlot.replaceChildren(p);
    };
    const ajaxSubmit = () => {
      const strings = window.themeStrings;
      submitBtn.disabled = true;
      fetch(newsletterForm.action, {
        method: 'POST',
        body: new FormData(newsletterForm),
        headers: { 'Accept': 'text/html' }
      })
        .then(r => r.text().then(html => ({ r, html })))
        .then(({ r, html }) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fehler = doc.querySelector('#newsletter-form .footer__newsletter-error');
          const erfolg = r.ok && (r.url.includes('customer_posted=true')
            || doc.querySelector('#newsletter-form .footer__newsletter-success'));
          if (erfolg) {
            zeigeStatus('footer__newsletter-success', strings.newsletterSuccess);
            newsletterForm.reset();
          } else if (fehler) {
            zeigeStatus('footer__newsletter-error', fehler.textContent.trim());
          } else if (r.redirected) {
            // Shopify verlangt ein sichtbares Captcha: der POST landet per
            // Redirect auf /challenge?form_key=…. Denselben Weg gehen wie
            // der native Submit — die Challenge-Seite holt die Eingaben
            // ueber form_key aus sessionStorage (Vendor-Persistenz) und
            // postet nach dem Loesen selbst. NICHT nativ nachschicken: das
            // Token ist verbraucht, Shopify antwortet «Invalid CAPTCHA
            // token» (Browser-Beleg 15.09.2026).
            window.location.assign(r.url);
          } else {
            nativeSubmit();
          }
        })
        .catch(() => zeigeStatus('footer__newsletter-error', strings.newsletterError))
        .finally(() => { submitBtn.disabled = false; });
    };
    newsletterForm.submit = ajaxSubmit;
    newsletterForm.addEventListener('submit', e => {
      // Mit aktivem Spam-Schutz uebernimmt dessen Listener (er ruft nach dem
      // Token form.submit = ajaxSubmit). Ohne Bootstrap (Schutz im Admin
      // ausgeschaltet) uebernehmen wir direkt.
      if (window.Shopify && window.Shopify.captcha) return;
      e.preventDefault();
      ajaxSubmit();
    });
  }

});